export default class SearchDropdown {

    constructor() {
        this.settings = {
            $searchTrigger : $('.js-search-trigger'),
            $searchReveal : $('.js-search-reveal')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$searchTrigger.length) {
            this.settings.$searchTrigger.on('click', () => {
                if(!$('.hamburger').hasClass('active')) {
                    this.settings.$searchReveal.toggleClass('scale-y-0 max-h-0');
                }
            });

            $('.hamburger').on('click', () => {
                this.settings.$searchReveal.addClass('scale-y-0 max-h-0');
            });
        }

    }
};

new SearchDropdown();